import React from 'react';
import Section from '@components/section';
import Text from '@components/text';
import Wrapper from '@components/wrapper.styled';
import { Content } from './embed';

export interface ImageSliceProps {
  title?: string;
  embedCode?: string;
}

const EmbedSlice = ({ embedCode, title }: ImageSliceProps): JSX.Element => {
  return (
    <Section backgroundColor="white">
      <Wrapper>
        <Content>
          {title && (
            <Text
              tag="h2"
              type="title"
              stringText={title}
              fontSize="heading3"
              margin="none"
              fontColor="secondary"
            />
          )}
          {/* eslint-disable-next-line react/no-danger */}
          {embedCode && <div dangerouslySetInnerHTML={{ __html: embedCode }} />}
        </Content>
      </Wrapper>
    </Section>
  );
};

export default EmbedSlice;
